module.exports = __webpack_public_path__ + "static/media/doctor-icon.b2c5cafc.svg";